export default "__VITE_ASSET__5hUDPdrX__"